// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3cy8l","list":"styles_list__1hFzA"};